import { useAuth } from '@/@diffrag/providers/user.provider'
import NavCollapsible from '@/@diffrag/sidebar/NavCollapsible'
import { useSideBarContext } from '@/@diffrag/sidebar/SideBarProvider'
import { api } from '@/api'
import { Button } from '@/components/ui/button'
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet'
import { cn } from '@/lib/utils'
import { LogOut, Menu } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import { useApi } from '../hooks/useApi'
import { NavLinks } from '../sidebar/type'
import { Box, Flex } from '@/@diffrag/components/base'

const year = new Date().getFullYear()

type Props = {
  navs: NavLinks[]
}

export const Header = ({ navs }: Props) => {
  const auth = useAuth()
  const navigate = useNavigate()
  const [drawer, openDrawer] = useState(false)
  const { setIsOpen } = useSideBarContext()
  const { pathname } = useLocation()

  const onClickPassword = () => {
    navigate('/auth/password')
  }

  const onClickLogout = () => {
    auth.logout()
  }

  useEffect(() => {
    if (drawer) setIsOpen(true)
  }, [drawer])

  return (
    <header className="sticky top-0 z-30 flex h-[60px] items-center gap-4 border-b border-slate-200 bg-white px-4 lg:px-4">
      <Sheet open={drawer} onOpenChange={openDrawer}>
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="size-8 shrink-0 md:hidden"
          >
            <Menu className="size-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="flex flex-col">
          <nav className="flex h-full flex-col items-stretch gap-1 overflow-y-auto px-4 text-sm font-medium">
            {navs.map(({ sub, roles, ...rest }) => (
              <NavCollapsible sub={sub} roles={roles} {...rest} />
            ))}
          </nav>
          <div className="my-auto grow text-sm text-muted-foreground">
            <a href="https://diffrag.com" target="_blank">
              © {year}. Diffrag
            </a>
          </div>
        </SheetContent>
      </Sheet>
      <Link to="/main" className="mr-10 flex items-center">
        <img src="/main-logo.png" alt="logo" className="h-8" />
      </Link>

      <div className="flex h-full items-center gap-2">
        <NavLink
          to="/main"
          className={({ isActive }) =>
            cn(
              'px-3 relative h-full flex items-center  text-slate-500 font-medium justify-center',
              {
                'text-slate-900 ': isActive,
              },
            )
          }
        >
          관리자
          {pathname.includes('/main') && (
            <div className="absolute bottom-0 left-0 h-[3px] w-full bg-[#167CF9]" />
          )}
        </NavLink>
        {/* <NavLink
          to="/stock"
          className={({ isActive }) =>
            cn(
              'px-3 relative h-full flex items-center  text-slate-500 font-medium justify-center',
              {
                'text-slate-900 ': isActive,
              },
            )
          }
        >
          재고관리
          {pathname.includes('/stock') && (
            <div className="absolute bottom-0 text-slate-500 left-0 w-full h-[3px] bg-[#167CF9]" />
          )}
        </NavLink>
        <NavLink
          to="/plan"
          className={({ isActive }) =>
            cn(
              'px-3 relative h-full flex items-center text-slate-500 font-medium justify-center',
              {
                'text-slate-900 ': isActive,
              },
            )
          }
        >
          납품계획
          {pathname.includes('/plan') && (
            <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#167CF9]" />
          )}
        </NavLink>
        {me?.role === 'MASTER_ADMIN' && (
          <NavLink
            to="/master"
            className={({ isActive }) =>
              cn(
                'px-3 relative h-full flex items-center  font-medium justify-center',
                {
                  'text-slate-900 ': isActive,
                },
              )
            }
          >
            마스터
            {pathname.includes('/master') && (
              <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#167CF9]" />
            )}
          </NavLink>
        )} */}
      </div>

      <div className="flex-1" />
      <Flex align="center">
        <Flex
          center
          className="rounded-[100px] border border-slate-200 bg-white px-[10px] py-0.5 text-[13px] font-medium leading-[13px]"
        >
          관리자
        </Flex>
        <Box className="mr-[10px]">
          <span className="ml-1 mr-0.5 text-[13px] leading-[18px]">
            {auth.user?.nickname}
          </span>
          <span className="text-[13px] leading-[18px]">님</span>
        </Box>
        <Button variant="outline" size="sm" onClick={onClickLogout}>
          <LogOut className="size-4 shrink-0" />
          <span className="ml-1 text-[13px] leading-[18px]">로그아웃</span>
        </Button>
      </Flex>
    </header>
  )
}
